import React, { useState, useEffect, useContext } from "react";
import SurveyConfigurationForm from "../../components/SurveyConfigurationForm";
import SurveyPreviewPanel from "../SurveyPreviewPanel";
import QuestionsPanel from "../../components/QuestionsPanel";
import {
  GeneralStyle,
  MenuItemWrapper,
  MenuWrapper,
  ConfigPanel,
  OnlyAssignedModal,
  TemplateContainer,
  SaveTemplate,
} from "./SurveyCreationMain.styled";
import PubSub from "pubsub-js";
import StyleContainer from "./../StyleContainer/StyleContainer";
import { GetURLParameter } from "../../util/UtilityFunctions";
import {
  setStateSurveyConfiguration,
  initialConfiguration,
} from "../../helpers/StateSurveyConfiguration";
import { getFile } from "../../services/FileManager";
import { ContextQuestions } from "../../Store/StoreQuestions";
import QuestionBankList from "../../components/QuestionBankList";
import ModalQuestionBank from "../../components/ModalQuestionBank/ModalQuestionBank";
import TemplateList from "../../components/TemplateList";
import { ReactComponent as SettingsIcon } from "../../assets/svg/notepad-settings-icon.svg";
import { ReactComponent as DesignIcon } from "../../assets/svg/design-icon.svg";
import { ReactComponent as QuestionIcon } from "../../assets/svg/question-icon.svg";
import { ReactComponent as QuestionBankIcon } from "../../assets/svg/questionbank-icon.svg";
import { ReactComponent as TemplateIcon } from "../../assets/svg/template-icon.svg";
import ModalSaveTemplate from "../../components/ModalSaveTemplate";
import ModalTemplatePreview from "../../components/ModalTemplatePreview";
import ModalConfirm from "../../components/ModalConfirm";
import { useMutation } from "@apollo/client";
import { APPLY_SURVEY_TEMPLATE } from "../../GraphQL/Mutations";
import { NotificationManager } from "react-notifications";
import PortalModal from "../../Portals";
import PropTypes from "prop-types";

const SurveyCreationMain = ({
  idSurvey,
  isIntegrated,
  isEditSurvey,
  dataEditSurvey,
  OnlyAssigned,
  onlyReviewWithComments,
  setShowSurveyCreationMain,
  ShowSurveyCreationMain,
}) => {
  const [, dispatch] = useContext(ContextQuestions);
  let integrated = GetURLParameter("isIntegrated") === "true";
  idSurvey = idSurvey > 0 ? idSurvey : parseInt(GetURLParameter("surveyId"));
  isIntegrated = integrated ? integrated : isIntegrated;
  const [isSavedAsTemplate, setIsSavedAsTemplate] = useState(false);
  const [selectedMenu, selectMenu] = useState("settings");
  const [saveBtnTxt, setSaveBtnTxt] = useState("");
  const [questionBlocks, setQuestionBlocks] = useState([]);
  const [title, setTitle] = useState("");
  const [styleTitle, setStyleTitle] = useState();
  const [surveyName, setSurveyName] = useState();
  const [surveyDescription, setSurveyDescription] = useState();
  const [footerText, setFooter] = useState("");
  const [selectedUsers, setSelectedUsers] = useState();
  const [selectedGuests, setSelectedGuests] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [styleQuestions, setStyleQuestions] = useState();
  const [styleAnswer, setStyleAnswer] = useState();
  const [styleSaveSurveyButton, setStyleSaveSurveyButton] = useState();
  let [keyAndId, setKeyAndId] = useState([]);
  const [styleBackground, setStyleBackground] = useState();
  const [styleLogo, setStyleLogo] = useState();
  const [, setDeleteQuestionBlocks] = useState("-1");
  const [Anonymity, setAnonymity] = useState(true);
  const [RandomQuestions, setRandomQuestions] = useState(false);
  const [selectedCategoryForBank, setSelectedCategoryForBank] = useState();
  const [openQuestionBankModal, setOpenQuestionBankModal] = useState(false);
  const [fetchSurvey, setFetchSurvey] = useState(false);
  const [openSurveyTemplateName, setOpenSurveyTemplateName] = useState(false);
  const [renderTemplateList, setRenderTemplateList] = useState(false);
  const [openTemplatePreview, setOpenTemplatePreview] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState();
  const [kindOfForm, setKindOfForm] = useState(
    dataEditSurvey?.surveyById.integrationTpclient
  );
  const [applyTemplate] = useMutation(APPLY_SURVEY_TEMPLATE);
  const [openApplyTmpConfirmation, setOpenApplyTmpConfirmation] =
    useState(false);

  const handleOpenQuestionBank = (selectedCategory) => {
    setSelectedCategoryForBank(selectedCategory);
  };

  const handleOpenTemplate = (template) => {
    setTemplateToPreview(template);
    setOpenTemplatePreview(true);
  };

  const handleApplyTemplate = () => {
    applyTemplate({
      variables: {
        templateId: templateToPreview?.id,
        surveyId: idSurvey,
      },
    })
      .then((response) => {
        if (!response?.data?.applyTemplate?.withError) {
          setFetchSurvey(!fetchSurvey);
          NotificationManager.success(
            "Template applied to survey successfully",
            "",
            5000
          );
        } else {
          NotificationManager.error(
            "Something went wrong in applying template",
            "",
            5000
          );
        }
      })
      .catch((error) => {
        NotificationManager.error(error.message, "", 5000);
      });
  };

  const handleSaveTemplate = () => {
    setOpenSurveyTemplateName(!openSurveyTemplateName);
  };

  useEffect(() => {
    if (selectedCategoryForBank?.id) setOpenQuestionBankModal(true);
  }, [selectedCategoryForBank]);

  const handleShowConfirmation = () => {
    setOpenApplyTmpConfirmation(true);
  };

  useEffect(() => {
    if (isEditSurvey) {
      if (dataEditSurvey) {
        let tpsurveyConfigurationSurveys =
          dataEditSurvey.surveyById?.tpsurveyConfigurationSurveys;

        let questions = tpsurveyConfigurationSurveys.filter(
          (f) => f.field === "Questions"
        );
        let answers = tpsurveyConfigurationSurveys.filter(
          (f) => f.field === "Answer"
        );
        if (questions.length) {
          dispatch({
            type: "QUESTIONS_STYLE",
            payload: JSON.parse(questions[0].jsonConfiguration),
          });
        }
        if (answers.length) {
          dispatch({
            type: "ANSWERS_STYLE",
            payload: JSON.parse(answers[0].jsonConfiguration),
          });
        }

        if (tpsurveyConfigurationSurveys) {
          let colorBackground = tpsurveyConfigurationSurveys.filter(
            (i) => i.field === "Background"
          )[0];
          let logo = tpsurveyConfigurationSurveys.filter(
            (i) => i.field === "Logo"
          )[0];

          if (logo) {
            getFile(JSON.parse(logo.jsonConfiguration).nameImage).then(
              (response) => {
                if (response && response.type !== "archivo-noexistente/json") {
                  PubSub.publish(
                    "urlPreviewImageLogo",
                    URL.createObjectURL(response)
                  );
                }
              }
            );
          }

          if (colorBackground) {
            getFile(
              JSON.parse(colorBackground.jsonConfiguration).nameImage
            ).then((response) => {
              if (response && response.type !== "archivo-noexistente/json") {
                PubSub.publish(
                  "urlPreviewImageBackground",
                  URL.createObjectURL(response)
                );
              }
            });
          }
        }

        initialConfiguration(tpsurveyConfigurationSurveys);

        let tpsurveyQuestionSurveys =
          dataEditSurvey.surveyById?.tpsurveyQuestionSurveys;

        PubSub.publish("updateClosedQuestion", []);
        keyAndId = [];

        setAnonymity(dataEditSurvey.surveyById?.isAnonymous);
        setRandomQuestions(dataEditSurvey.surveyById?.setRandomQuestions);

        tpsurveyQuestionSurveys
          .filter((f) => f.active)
          .sort((a, b) => (a.order >= b.order ? 1 : -1))
          .map((item, index) => {
            let jsonConfSurveyQuestion = JSON.parse(item.jsonConfiguration);

            dispatch({
              type: "ADD_QUESTIONS",
              payload: {
                Gtype: jsonConfSurveyQuestion.typeQuestion,
                GindexQuestion: index,
                Gactive: item.active,
                GidSurvey: idSurvey,
                GidQuestion: item.idQuestion,
                GidCategoryQuestion:
                  item.idQuestionNavigation.idCategoryQuestion.toString(),
                GnameQuestion: item.idQuestionNavigation.nameQuestion,
                GvalidationText: item.idQuestionNavigation.validationText,
                GidQuestionSurvey: item.idQuestionSurvey,
                GisMandatory: item.isMandatory,
                GjsonConfiguration: item.jsonConfiguration,
                Gorder: item.order,
                GisEdit: false,
                GisDependent: item.isDependent,
                GidParentQuestion: item.isDependent ? item.idParentQuestion : 0,
                GdependentAnswer: item.isDependent ? item.dependentAnswer : "",
              },
            });
          });
        setSurveyName(dataEditSurvey?.surveyById?.surveyName)
        setSurveyDescription(dataEditSurvey?.surveyById?.surveyDescription)
      }
    }
  }, [dataEditSurvey]);

  useEffect(() => {
    PubSub.subscribe("surveyConfiguration", (e, data) => {      
      let surveyNameTmp = data.filter((i) => i.field === "surveyName")[0];
      let surveyDescriptionTmp = data.filter(
        (i) => i.field === "surveyDescription"
      )[0];
      let titleTmp = data.filter((i) => i.field === "Title")[0];
      let footerTmp = data.filter((i) => i.field === "Footer")[0];
      let questionsTmp = data.filter((i) => i.field === "Questions")[0];
      let answerTmp = data.filter((i) => i.field === "Answer")[0];
      let TextButtonSaveTmp = data.filter(
        (i) => i.field === "TextButtonSave"
      )[0];
      let BackgroundTmp = data.filter((i) => i.field === "Background")[0];
      let LogoTmp = data.filter((i) => i.field === "Logo")[0];
      let selectedUsersTmp = data.filter((i) => i.field === "SelectedUsers")[0];

      setSurveyName(
        surveyNameTmp
          ? data.filter((i) => i.field === "surveyName")[0]?.configurationJson
              .text
          : ""
      );

      setSurveyDescription(
        surveyDescriptionTmp
          ? data.filter((i) => i.field === "surveyDescription")[0]
              ?.configurationJson.text
          : ""
      );

      setTitle(
        titleTmp
          ? data.filter((i) => i.field === "Title")[0]?.configurationJson.text
          : ""
      );

      setStyleTitle(
        titleTmp
          ? data.filter((i) => i.field === "Title")[0]?.configurationJson
          : null
      );

      setFooter(
        footerTmp
          ? data.filter((i) => i.field === "Footer")[0]?.configurationJson.text
          : ""
      );

      setSaveBtnTxt(
        TextButtonSaveTmp
          ? data.filter((i) => i.field === "TextButtonSave")[0]
              ?.configurationJson.text
          : ""
      );

      setSelectedUsers(
        selectedUsersTmp
          ? data.filter((i) => i.field === "SelectedUsers")[0].configurationJson
              .users
          : ""
      );

      setStyleQuestions(
        questionsTmp
          ? data.filter((i) => i.field === "Questions")[0]?.configurationJson
          : null
      );

      setStyleAnswer(
        answerTmp
          ? data.filter((i) => i.field === "Answer")[0]?.configurationJson
          : null
      );
      setStyleSaveSurveyButton(
        TextButtonSaveTmp
          ? data.filter((i) => i.field === "TextButtonSave")[0]
              ?.configurationJson
          : null
      );

      setStyleBackground(
        BackgroundTmp ? BackgroundTmp?.configurationJson : null
      );

      setStyleLogo(LogoTmp ? LogoTmp?.configurationJson : null);
    });

    setStateSurveyConfiguration([], "SurveyGroupIds");
    setStateSurveyConfiguration([], "SelectedUsers");
    return () => {
      PubSub.unsubscribe("surveyConfiguration");
    };
  }, []);

  let handleDeleteQuestion = (KeyId) => {
    let key = [];
    key.push(KeyId.toString());
    setDeleteQuestionBlocks(key);
  };

  const handleDisplayMenu = () => {
    switch (selectedMenu) {
      case "settings":
        return (
          <SurveyConfigurationForm
            footerText={footerText}
            surveyNameProp={surveyName}
            surveyDescriptionProp={surveyDescription}
            title={title}
            saveBtnTxt={saveBtnTxt}
            idSurvey={parseInt(idSurvey)}
            selectedUsers={selectedUsers}
            selectedGuests={selectedGuests}
            setSelectedGuests={setSelectedGuests}
            selectedGroups={selectedGroups}
            setSelectedGroups={setSelectedGroups}
            OnlyAssigned={OnlyAssigned}
            onlyReviewWithComments={onlyReviewWithComments}
            Anonymity={Anonymity}
            setAnonymity={setAnonymity}
            RandomQuestions={RandomQuestions}
            setRandomQuestions={setRandomQuestions}
            itsForm={kindOfForm}
          />
        );
      case "style":
        let styleFormAll = {
          styleTitle: styleTitle,
          styleQuestions: styleQuestions,
          styleAnswer: styleAnswer,
          styleSaveSurveyButton: styleSaveSurveyButton,
          styleBackground: styleBackground,
          styleLogo: styleLogo,
        };

        return (
          <StyleContainer
            footerText={footerText}
            styleFormAll={styleFormAll}
            questionBlocks={questionBlocks}
            setQuestionBlocks={setQuestionBlocks}
            key={questionBlocks.length}
            idSurvey={parseInt(idSurvey)}
            setKeyAndId={setKeyAndId}
            keyAndId={keyAndId}
            blockKey={questionBlocks.length}
            handleDeleteQuestion={handleDeleteQuestion}
          />
        );
      case "questions":
        return (
          <QuestionsPanel
            idSurvey={parseInt(idSurvey)}
            isIntegrated={isIntegrated}
            questionBlocks={questionBlocks}
            setQuestionBlocks={setQuestionBlocks}
            setKeyAndId={setKeyAndId}
            keyAndId={keyAndId}
            isEditSurvey={isEditSurvey}
            dataEditSurvey={dataEditSurvey}
            styleAnswer={styleAnswer}
            styleQuestions={styleQuestions}
            handleDeleteQuestion={handleDeleteQuestion}
          />
        );
      case "questionbank":
        return (
          <QuestionBankList handleOpenQuestionBank={handleOpenQuestionBank} />
        );
      case "templates":
        return (
          <TemplateContainer>
            <SaveTemplate onClick={handleSaveTemplate}>
              {kindOfForm ? "Save form as template" : "Save survey as template"}
            </SaveTemplate>
            <TemplateList
              handleOpen={handleOpenTemplate}
              renderList={renderTemplateList}
            />
          </TemplateContainer>
        );
      default:
        break;
    }
  };

  return (
    <>
      <GeneralStyle>
        <ConfigPanel>
          <MenuWrapper selectedMenu={selectedMenu}>
            <MenuItemWrapper
              id="settings"
              onClick={() => selectMenu("settings")}
            >
              <SettingsIcon />
              Settings
            </MenuItemWrapper>
            <MenuItemWrapper
              id="style"
              disabled={onlyReviewWithComments}
              onClick={() => {
                if (!onlyReviewWithComments) {
                  selectMenu("style");
                }
              }}
            >
              <DesignIcon />
              Design
            </MenuItemWrapper>
            <MenuItemWrapper
              id="questions"
              disabled={onlyReviewWithComments}
              onClick={() => {
                if (!onlyReviewWithComments) {
                  selectMenu("questions");
                }
              }}
            >
              <QuestionIcon />
              Questions
            </MenuItemWrapper>
            <MenuItemWrapper
              id="questionbank"
              hidden={
                ShowSurveyCreationMain?.isGlobal ||
                dataEditSurvey?.surveyById?.isGlobal
              }
              disabled={onlyReviewWithComments}
              style={{ textAlign: "center" }}
              onClick={() => {
                if (!onlyReviewWithComments) {
                  selectMenu("questionbank");
                }
              }}
            >
              <QuestionBankIcon />
              Question Bank
            </MenuItemWrapper>
            <MenuItemWrapper
              id="templates"
              disabled={onlyReviewWithComments}
              style={{ textAlign: "center" }}
              onClick={() => {
                if (!onlyReviewWithComments) {
                  selectMenu("templates");
                }
              }}
            >
              <TemplateIcon />
              Templates
            </MenuItemWrapper>
            {/* <MenuItemWrapper id="bank" onClick={() => selectMenu('bank')}>
          <BankQuestions />
        </MenuItemWrapper> */}
          </MenuWrapper>
          <hr className="menu-hr" />
          {handleDisplayMenu()}
        </ConfigPanel>
        <SurveyPreviewPanel
          idSurvey={idSurvey}
          isSavedAsTemplate={isSavedAsTemplate}
          ShowSurveyCreationMain={ShowSurveyCreationMain}
          styleTitle={styleTitle}
          styleSaveSurveyButton={styleSaveSurveyButton}
          OnlyAssigned={OnlyAssigned}
          Anonymity={Anonymity}
          RandomQuestions={RandomQuestions}
          onlyReviewWithComments={onlyReviewWithComments}
          fetchSurvey={fetchSurvey}
          setShowSurveyCreationMain={setShowSurveyCreationMain}
          integrationTpClient={dataEditSurvey?.surveyById.integrationTpclient}
          selectedGuests={selectedGuests}
        />
      </GeneralStyle>

      {OnlyAssigned && <OnlyAssignedModal></OnlyAssignedModal>}
      {openQuestionBankModal && (
        <ModalQuestionBank
          category={selectedCategoryForBank}
          setModalVisibility={setOpenQuestionBankModal}
          surveyId={idSurvey}
          setFetchSurvey={setFetchSurvey}
          fetchSurvey={fetchSurvey}
        />
      )}
      {openSurveyTemplateName && (
        <ModalSaveTemplate
          surveyId={idSurvey}
          isSavedAsTemplate={isSavedAsTemplate}
          setIsSavedAsTemplate={setIsSavedAsTemplate}
          setModalVisibility={setOpenSurveyTemplateName}
          renderTemplateList={renderTemplateList}
          setRenderTemplateList={setRenderTemplateList}
        />
      )}
      {openTemplatePreview && (
        <PortalModal>
            <ModalTemplatePreview
              template={templateToPreview}
              setModalVisibility={setOpenTemplatePreview}
              handleApplyTemplate={handleShowConfirmation}
            />
          </PortalModal>
      )}
      {openApplyTmpConfirmation && (
        <ModalConfirm
          info="Your data will be replaced with the selected template.Are you sure about this?"
          handleConfirm={handleApplyTemplate}
          setModalVisibility={setOpenApplyTmpConfirmation}
        />
      )}
    </>
  );
};

export default SurveyCreationMain;

SurveyCreationMain.propTypes = {
  idSurvey: PropTypes.number,
  ShowSurveyCreationMain: PropTypes.any,
  isIntegrated: PropTypes.bool,
  isEditSurvey: PropTypes.bool,
  dataEditSurvey: PropTypes.any,
  OnlyAssigned: PropTypes.any,
  onlyReviewWithComments: PropTypes.any,
  setShowSurveyCreationMain: PropTypes.func,
};
